import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ColumnFilter, ColumnSort } from "@tanstack/react-table";
import { INITIAL_PAGING, STATUS_INITIAL, STATUS_LOADING, STATUS_SUCCEEDED } from "myParkdUtils/constants";
import { PagingReactTable, ParkdCard, Status } from "types";


export type ParkdCardsState = {
    parkingCards: ParkdCard[],
    paging: PagingReactTable,
    getStatus: Status
}

export const initialParkdCardsState: ParkdCardsState = {
    parkingCards: [],
    paging: INITIAL_PAGING,
    getStatus: STATUS_INITIAL
};


export const parkdCardsSlice = createSlice({
    name: 'parkdCards',
    initialState: initialParkdCardsState,
    reducers: {
        getParkdCards(state, action: PayloadAction<{ paging: PagingReactTable, filters?: ColumnFilter[], sorting?: ColumnSort[] }>) {
            state.getStatus = STATUS_LOADING;
            state.parkingCards = [];
            state.paging.currentPage = action.payload.paging.currentPage;
            state.paging.pageSize = action.payload.paging.pageSize;
        },
        getParkdCardsCompleted(state, action: PayloadAction<{ parkingCards: ParkdCard[], totalElements: number, totalPages: number }>) {
            state.getStatus = STATUS_SUCCEEDED;
            state.parkingCards = action.payload.parkingCards;
            state.paging.totalElements = action.payload.totalElements;
            state.paging.totalPages = action.payload.totalPages;
        },
        getParkdCardsError(state, action: PayloadAction<{ error: any }>) {
            state.getStatus = {
                ...STATUS_INITIAL,
                error: action.payload.error
            }
        }
    }
});

export const parkdCardsSliceActions = parkdCardsSlice.actions;

export default parkdCardsSlice.reducer;